import './index.css';

import BasicInfo from './BasicInfo';
import { Bot, Candle, Subscription, SubscriptionBalance } from '../types';
import Price from './Price';

interface Props {
  bot: Bot;
  latestPrice: Candle | undefined;
  subscription: Subscription;
  subscriptionBalance: SubscriptionBalance;
  earliestTimestamp: number | undefined;
}

const Header: React.FC<Props> = (props: Props) => {
  const {
    bot,
    subscription,
    subscriptionBalance,
    latestPrice,
    earliestTimestamp,
  } = props;

  return (
    <div className="detail-container">
      <BasicInfo
        bot={bot}
        subscription={subscription}
        subscriptionBalance={subscriptionBalance}
      />
      <Price
        latestPrice={latestPrice}
        bot={bot}
        earliestTimestamp={earliestTimestamp}
      />
    </div>
  );
};

export default Header;
